import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import SelectAutocomplete from "../../components/selectAutocomplete/SelectAutocomplete";
import Utils from "../../utils/Utils";
import SessioneUtente from "../../sessionManager/SessioneUtente";
import Ruoli from "../../utils/Ruoli.json";
import Input from "../../components/textbox/Input";
import Calendar from "../../components/calendar/Calendar";
import Spinner from "../../components/spinner/Spinner";
import Button from "../../components/button/Button";
import ToasterSingleton from "../../singleton/ToasterSingleton";
import toasterConfig from "../../config/toasterConfig";
import $ from "jquery";
import Table from "../../components/table/Table";
import {states} from "../Wizard/States/States";
import OggettiUtili from "../../utils/OggettiUtili.json";
import SegnalazioniService from "../../services/SegnalazioniServices";

class RicercaContactTracing extends Component {

    state = {
        malattia: "",
        nome: "",
        cognome: "",
        dataDa: "",
        dataA: "",
        malattieUtenteLaboratorio: JSON.parse(sessionStorage.getItem("malattieUtenteLaboratorioPerDescrizione")),
        malattie: JSON.parse(sessionStorage.getItem("malattiePerDescrizione")),
        showSpinner: false,
        disabledPulisciCampi: true,
        disableRicercaSegnalazioni: true,
        totalElements: 0,
        showTable: false,
        page: 0,
        totalPages: 0,
        size: 10,
        rows:[]
    }

    cols = [
        {
            key: "idSegnalazione",
            name: "Tables.RicercaSegnalazioni.id",
            sortDirection: "none",
            tipo: "link",
            path: "/wizardSegnalazione",
            nomeParametro: "idSegnalazione",
            state: {currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI}
        },
        {
            key: "malattia",
            name: "Tables.RicercaSegnalazioni.malattia",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: this.state.malattie,
            campo: "descrizione"
        },
        {key: "paziente", name: "Tables.RicercaSegnalazioni.paziente", sortDirection: "none"},
        {
            key: "ulssSegnalazione",
            name: "Tables.Home.ulssSegn",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {key: "dataSegnalazione", name: "Tables.RicercaSegnalazioni.data", sortDirection: "none", tipo: "data"},
        {key: "numeroContatti", name: "Tables.RicercaSegnalazioni.numeroContatti", sortDirection: "none"},
        {
            key: "statoSegnalazione",
            name: "Tables.RicercaSegnalazioni.stato",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.statoSegnalazione
        }
    ]

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.pulisciTutto = this.pulisciTutto.bind(this)
        this.ricercaSegnalazioni = this.ricercaSegnalazioni.bind(this)
        this.onClickRicerca = this.onClickRicerca.bind(this)
        this.aggiungiToaster = this.aggiungiToaster.bind(this)
        this.disabledButtons = this.disabledButtons.bind(this)
        this.changePageTable = this.changePageTable.bind(this);
        this.changePaginationTable = this.changePaginationTable.bind(this);
    }

    componentDidMount() {
        ToasterSingleton.instance().pulisci()
        ToasterSingleton.instance().sottoscrizione(this)
        sessionStorage.setItem("pathProvenienza", this.props.pathProvenienza)
        let paramsRicerca = sessionStorage.getItem(
            "parametriRicercaContactTracing"
        )
            ? JSON.parse(sessionStorage.getItem("parametriRicercaContactTracing"))
            : null;
        if (paramsRicerca) {
            this.setState({
                malattia: paramsRicerca.malattia || "",
                cognome: paramsRicerca.cognome || "",
                nome: paramsRicerca.nome || "",
                dataDa: paramsRicerca.dataDa || "",
                dataA: paramsRicerca.dataA || ""
            });
            this.ricercaSegnalazioni(paramsRicerca)
        }
    }

    componentDidUpdate() {
        sessionStorage.setItem("pathProvenienza", this.props.pathProvenienza)
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione()
    }

    aggiungiToaster() {
        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.informational,
            text: ["Toasters.Messages.no_result"],
            timestamp: Date.now()
        })
    }

    disabledButtons(newState) {
        newState.disabledPulisciCampi = !(newState.malattia || newState.dataDa || newState.dataA || newState.nome || newState.cognome);
        newState.disableRicercaSegnalazioni = !(newState.malattia || (newState.nome && newState.cognome) || (newState.dataA && newState.dataDa));
        this.setState(newState)
    }

    riceviValore(field, event) {
        let newState = this.state
        newState[field] = event.target.value
        this.disabledButtons(newState)
    }

    pulisciTutto() {
        let newState = this.state
        newState.malattia = ""
        newState.nome = ""
        newState.cognome = ""
        newState.dataA = ""
        newState.dataDa = ""
        newState.rows = []
        newState.showTable = false
        document.getElementById("malattia").value = "";
        $(document).ready(function () {
            $('.selectpicker').selectpicker('refresh')
        });
        this.disabledButtons(newState)
        sessionStorage.removeItem("parametriRicercaContactTracing");
    }

    buildParams(sort, direction, page, size){
        let params = {
            malattia: this.state.malattia,
            nome: this.state.nome,
            cognome: this.state.cognome,
            dataDa: this.state.dataDa,
            dataA: this.state.dataA,
            page: page??"",
            sort: sort??"",
            order: direction??"",
            size:size??10,
            ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione
                || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione
                ? SessioneUtente.getInstance().ulss : null
        }

        return Utils.removeEmptyValueFromObject(params)
    }

    onClickRicerca(){
        this.setState({showSpinner: true});
        let params = this.buildParams()
        this.ricercaSegnalazioni(params)
        sessionStorage.setItem(
            "parametriRicercaContactTracing",
            JSON.stringify(params)
        );
    }

    ricercaSegnalazioni(params) {

        SegnalazioniService.getSegnalazioni(params).then(res => {
            if (!res.data.content || res.data.content.length === 0) {
                this.aggiungiToaster();
            }
            let segnalazioni = SegnalazioniService.mapGetSegnalazioni(res);
            let newState = {
                rows: segnalazioni, totalElements: res.data.totalElements, showTable: true,
                totalPages: res.data.totalPages, showSpinner: false
            }

            if (params.size && params.size !== this.state.size) {
                newState["size"] = params.size
            }
            if ((params.page || params.page === 0) && params.page !== this.state.page) {
                newState["page"] = params.page
            }

            this.setState(newState);
        }).catch(reason => {
            let state = {rows: [], totalElements: 0, showTable: true, showSpinner: false, page: 0}
            if (params.size && params.size !== this.state.size) {
                state["size"] = params.size
            }
            if ((params.page || params.page === 0) && params.page !== this.state.page) {
                state["page"] = params.page
            }
            console.log("[Error] GetSegnalazioni in errore: " + reason);
            this.setState(state);
        })
    }

    changePageTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);
        if (size != null && size !== this.state.size) {
            size = this.state.size
        }
        this.ricercaSegnalazioni(this.buildParams(sort, direction, page, size))
        sessionStorage.setItem(
            "parametriRicercaContactTracing",
            JSON.stringify(params)
        );
    }

    changePaginationTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);
        this.ricercaSegnalazioni(this.buildParams(sort, direction, page, size))
        sessionStorage.setItem(
            "parametriRicercaContactTracing",
            JSON.stringify(params)
        );
    }

    render() {
        const {t} = this.props
        const bluButton = "btnBlu";
        const whiteButton = "btnWhite";
        return (
            <div className={styles.contenitore}>
                {ToasterSingleton.instance().renderToaster()}
                {this.state.showSpinner ? <Spinner/> : null}
                <p>{t("GestioneSegnalazioni.ricerca.malattia")} <span
                    className={styles.mandatoryColor}>*</span></p>
                <SelectAutocomplete
                    id={"malattia"}
                    field={"malattia"}
                    newSelect={true}
                    onChange={this.riceviValore}
                    value={this.state.malattia}
                    functionMap={Utils.mapToArray(SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione ? this.state.malattieUtenteLaboratorio : this.state.malattie).map((oggetto) => {
                        return (<option value={oggetto.codice}>{oggetto.codDesc}</option>)
                    })}>
                </SelectAutocomplete>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-6"}>
                        <p>{t("GestioneSegnalazioni.ricerca.cognome")} <span
                            className={styles.mandatoryColor}>*</span></p>
                        <Input id={"cognome"}
                               onChange={this.riceviValore}
                               field={"cognome"}
                               value={this.state.cognome}
                               placeholder={t("GestioneSegnalazioni.ricerca.cognome")}/>
                    </div>
                    <div className={"col-6"}>
                        <p>{t("GestioneSegnalazioni.ricerca.nome")} <span
                            className={styles.mandatoryColor}>*</span></p>
                        <Input id={"nome"}
                               onChange={this.riceviValore}
                               field={"nome"}
                               value={this.state.nome}
                               placeholder={t("GestioneSegnalazioni.ricerca.nome")}/>
                    </div>
                </div>
                <p style={{marginTop: "1rem"}}>{t("GestioneSegnalazioni.ricerca.data_segnalazione")} <span
                    className={styles.mandatoryColor}>*</span></p>
                <div className={styles.responsiveGrid}>
                    <div className={styles.dataSegnalazioneGroup}>
                        <label className={styles.labelStyle} htmlFor="da">{t("Utils.da")}</label>
                        <Calendar id={"dataDa"} value={this.state.dataDa}
                                  newCalendar={true}
                                  onChange={this.riceviValore} field={"dataDa"}
                                  errorMessage={Utils.isDateInValid(this.state.dataDa) ? "Data non valida. Inserire 'data segnalazione Da' valida" : ""}
                                  error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataDa), "-") &&
                                      this.state.dataDa !== ""}/>
                        <label className={styles.labelStyle} htmlFor="da">{t("Utils.a")}</label>
                        <Calendar id={"dataA"} value={this.state.dataA}
                                  newCalendar={true}
                                  onChange={this.riceviValore} field={"dataA"}
                                  errorMessage={Utils.isDateInValid(this.state.dataA) ? "Data non valida. Inserire 'data segnalazione Da' valida" : ""}
                                  error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataA), "-") &&
                                      this.state.dataA !== ""}>
                        </Calendar>
                    </div>
                </div>
                <div className={styles.mandatoryColor} style={{marginTop:"1rem"}}>{t("GestioneSegnalazioni.ricerca.legenda_obbligatorio")}</div>
                <div className={"row"}>
                    <Button id={"pulisciTutto"} text={t("Buttons.clean")} disabled={this.state.disabledPulisciCampi}
                            onClick={this.pulisciTutto}
                            className={[whiteButton, "col-sm-12 col-lg-3 mx-lg-auto"].join(" ")}
                            style={{height: "3rem", marginTop: "1rem"}}></Button>
                    <Button id={"ricercaSegnalazioni"} text={t("Buttons.search")}
                            disabled={this.state.disableRicercaSegnalazioni}
                            onClick={this.onClickRicerca}
                            className={[bluButton, "col-sm-12 col-lg-3 mx-lg-auto"].join(" ")}
                            style={{height: "3rem", marginTop: "1rem"}}></Button>
                </div>
                {this.state.showTable ?
                    <div id="contenitoreTabella" className={styles.contenitoreTabella}>
                        <Table cols={this.cols} rows={this.state.rows}
                               title={t("GestioneSegnalazioni.ricerca.titolo_tabella")}
                               empty={!this.state.rows}
                               emptyMsg={t("Tables.RicercaSegnalazioni.noSegnalazioni")}
                               lengthEditable={true}
                               totalElements={this.state.totalElements}
                               bigTable={true}
                               totalPages={this.state.totalPages}
                               page={this.state.page}
                               changePage={this.changePageTable}
                               changePagination={this.changePaginationTable}
                        />
                    </div> : null}

            </div>
        )
    }

}

export default withTranslation('common')(RicercaContactTracing);